export const termsConditionData = [
  {
    heading: "1. Definitions",
    content: [
      {
        type: "content",
        value:
          "Account: An account created by you to access and use the Services.",
      },
      {
        type: "content",
        value:
          "Consumer: The end-user utilizing the pay-by-bank payment method facilitated by Fipay.io through Merchant integration.",
      },
      {
        type: "content",
        value:
          "Merchant: You, the business or individual integrating Fipay.io to offer pay-by-bank payment options to Consumers.",
      },
      {
        type: "content",
        value:
          "Payment Processor: Third-party service providers used by Fipay.io to facilitate payment processing.",
      },
      {
        type: "content",
        value:
          "Services: The Fipay.io Platform, including all features, functionalities, and tools offered.",
      },
    ],
  },
  {
    heading: "2. Eligibility",
    content: [
      {
        type: "content",
        value:
          "You must be at least 18 years old and have the legal capacity to enter into a binding contract to use our Services.",
      },
      {
        type: "content",
        value:
          "By using our Services, you represent and warrant that you meet these eligibility requirements.",
      },
    ],
  },
  {
    heading: "3. Use of Services",
    content: [
      {
        subheading: "3.1 Merchants",
        content: [
          {
            type: "content",
            value:
              "You are responsible for all activity occurring under your Account.",
          },
          {
            type: "content",
            value:
              "You agree to comply with all applicable laws and regulations, including Anti-Money Laundering (AML) and Know Your Customer (KYC) rules.",
          },
          {
            type: "content",
            value:
              "You will not use the Services for prohibited purposes, including but not limited to:",
          },
          {
            type: "list",
            value: [
              "Money laundering or terrorist financing",
              "Fraudulent activities",
              "Illegal online gambling",
              "Sales of weapons, ammunition, or illegal drugs",
              "Transactions with sanctioned individuals or entities",
            ],
          },
          {
            type: "content",
            value:
              "You must provide accurate and complete information when registering for an Account.",
          },
          {
            type: "content",
            value:
              "You are responsible for maintaining the confidentiality of your login credentials.",
          },
        ],
      },
      {
        subheading: "3.2 Consumers",
        content: [
          {
            type: "content",
            value:
              "Consumers acknowledge that third-party payment processors facilitate pay-by-bank transactions.",
          },
          {
            type: "content",
            value:
              "You agree to comply with the terms and privacy policies of these third-party providers.",
          },
          {
            type: "content",
            value:
              "You must not use the Services for any unauthorized or illegal purpose.",
          },
        ],
      },
    ],
  },
  {
    heading: "4. Third-Party Services",
    content: [
      {
        type: "content",
        value:
          "The Services may integrate with third-party providers (e.g., payment processors, data providers).",
      },
      {
        type: "content",
        value:
          "Your use of these third-party services is subject to their respective terms and conditions.",
      },
      {
        type: "content",
        value:
          "Fipay.io is not liable for the actions, omissions, or policies of these third parties.",
      },
    ],
  },
  {
    heading: "5. Information Collection",
    content: [
      {
        type: "content",
        value:
          "Information You Provide: Name, email, phone number, and business details provided during Account setup.",
      },
      {
        type: "content",
        value:
          "Information Automatically Collected: IP address, browser type, device information, and usage activity.",
      },
      {
        type: "content",
        value: "For more details, please review our Privacy Policy.",
      },
    ],
  },
  {
    heading: "6. User-Generated Content",
    content: [
      {
        type: "content",
        value:
          "Certain features may allow you to submit or post content (e.g., reviews, feedback).",
      },
      {
        type: "content",
        value: "You are solely responsible for any content you submit.",
      },
      {
        type: "content",
        value:
          "You represent that your content does not violate any laws or infringe upon any third-party rights.",
      },
    ],
  },
  {
    heading: "7. Sensitive Information",
    content: [
      {
        type: "content",
        value:
          "We do not knowingly collect sensitive personal data (e.g., Social Security numbers, financial passwords).",
      },
      {
        type: "content",
        value:
          "If you accidentally provide such data, contact us immediately to have it removed.",
      },
    ],
  },
  {
    heading: "8. Disclosure of Personal Information",
    content: [
      {
        type: "content",
        value:
          "Service Providers: Payment processors, data processors, and customer support.",
      },
      {
        type: "content",
        value:
          "Legal Requirements: To comply with laws, regulations, or governmental requests.",
      },
      {
        type: "content",
        value:
          "Business Transfers: In case of a merger, acquisition, or sale of assets.",
      },
      {
        type: "content",
        value: "With Your Consent: When you explicitly authorize sharing.",
      },
    ],
  },
  {
    heading: "9. User Rights",
    content: [
      {
        type: "content",
        value:
          "You may have rights regarding your personal data, including access, correction, and deletion.",
      },
      {
        type: "content",
        value: "Contact us at info@fipay.io to exercise these rights.",
      },
    ],
  },
  {
    heading: "10. Compliance and Risk Management",
    content: [
      {
        type: "content",
        value:
          "Fipay.io reserves the right to suspend or terminate Accounts if we detect activities that:",
      },
      {
        type: "list",
        value: ["Violate these Terms", "Pose compliance or legal risks"],
      },
    ],
  },
  {
    heading: "11. Children’s Policy",
    content: [
      {
        type: "content",
        value:
          "Our Services are not intended for individuals under the age of 13.",
      },
      {
        type: "content",
        value:
          "We do not knowingly collect personal information from children under 13.",
      },
    ],
  },
  {
    heading: "12. Dispute Resolution",
    content: [
      {
        type: "content",
        value:
          "Disputes will first be addressed through Fipay.io’s internal dispute management system.",
      },
      {
        type: "content",
        value:
          "If unresolved, disputes will be governed by the terms in Section 13 (Governing Law).",
      },
    ],
  },
  {
    heading: "13. Governing Law and Jurisdiction",
    content: [
      {
        type: "content",
        value:
          "These Terms are governed by the laws of the State of Delaware, USA.",
      },
      {
        type: "content",
        value:
          "Any legal claims or disputes will be resolved exclusively in state or federal courts located in Delaware.",
      },
    ],
  },
  {
    heading: "14. Disclaimers",
    content: [
      {
        type: "content",
        value:
          "The Services are provided 'as is' and 'as available' without warranties of any kind.",
      },
      {
        type: "content",
        value: "We do not guarantee uninterrupted or error-free services.",
      },
      { type: "content", value: "You use the Services at your own risk." },
    ],
  },
  {
    heading: "15. Limitation of Liability",
    content: [
      { type: "content", value: "To the maximum extent permitted by law:" },
      {
        type: "list",
        value: [
          "Fipay.io shall not be liable for indirect, incidental, or consequential damages.",
          "Our total liability shall not exceed the amount paid by you to us in the past 12 months.",
        ],
      },
    ],
  },
  {
    heading: "16. Indemnification",
    content: [
      {
        type: "content",
        value:
          "You agree to indemnify, defend, and hold harmless Fipay.io, its employees, directors, and affiliates from any claims, losses, damages, or legal fees arising from:",
      },
      {
        type: "list",
        value: ["Your violation of these Terms", "Your misuse of the Services"],
      },
    ],
  },
  {
    heading: "17. Termination",
    content: [
      {
        type: "content",
        value:
          "We may terminate or suspend your access to the Services at any time, with or without notice.",
      },
      { type: "content", value: "You may terminate your Account at any time." },
    ],
  },
  {
    heading: "18. Changes to These Terms",
    content: [
      {
        type: "content",
        value:
          "We reserve the right to update or modify these Terms at any time.",
      },
      {
        type: "content",
        value:
          "Material changes will be notified by updating the 'Last Updated' date and posting the revised Terms on our website.",
      },
      {
        type: "content",
        value:
          "Continued use of the Services after changes constitutes acceptance of the revised Terms.",
      },
    ],
  },
  {
    heading: "19. Entire Agreement",
    content: [
      {
        type: "content",
        value:
          "These Terms constitute the entire agreement between you and Fipay.io, superseding any prior agreements.",
      },
    ],
  },
  {
    heading: "20. Severability",
    content: [
      {
        type: "content",
        value:
          "If any provision of these Terms is found to be invalid or unenforceable, the remaining provisions will remain in effect.",
      },
    ],
  },
  {
    heading: "21. Contact Us",
    content: [
      {
        type: "content",
        value:
          "If you have any questions regarding these Terms, please contact us at: Email: info@fipay.io",
      },
    ],
  },
];
